import { Vector2 } from '@babylonjs/core/Maths/math.vector';
import { setStyle } from 'redom';

import { SystemLayer } from '../System/systemLayer';
import { SceneryCamera } from '../Scenery/sceneryCamera';
import { Animation } from '../System/Animation/animation';
import { Ease, EaseMode } from '../System/Animation/animationEasing';
import { UiElement } from './uiElement';

export class UiDragAnimation extends UiElement {
    private sceneryCamera: SceneryCamera;

    private anim: Animation;

    private animEase: Animation;

    constructor(
        system: SystemLayer,
        container: HTMLElement,
        sceneryCamera: SceneryCamera,
    ) {
        super(system, container);
        setStyle(this.el, {
            background: 'url("https://d23jutsnau9x47.cloudfront.net/studio/images/drag-icon.png")',
            'background-origin': 'initial',
            'background-position': 'center',
            'background-repeat': 'no-repeat',
            'background-size': 'contain',
        });
        this.hide();
        this.setSize({ width: 60, height: 60 });
        this.sceneryCamera = sceneryCamera;

        this.system.canvas.addEventListener('pointerdown', () => {
            this.stopAnimation();
        });

        this.anim = new Animation(this.system, 20);
        this.animEase = new Animation(this.system, 20);
        this.animEase.setEasing(Ease.Cubic, EaseMode.InOut);
    }

    public set start(v : boolean) {
        const dragSensibility = this.sceneryCamera.getDraggableSensibility();
        if (v && (dragSensibility.x !== 0 || dragSensibility.y !== 0)) {
            this.startAnimation();
        } else {
            this.stopAnimation();
        }
    }

    private currentTimeout

    private startAnimation() {
        if (this.running) return;
        this.running = true;
        //! Stop animation first to make sure the last currentTimeout is cleared
        this.anim.stop();
        if (this.currentTimeout) clearTimeout(this.currentTimeout);
        this.currentTimeout = setTimeout(() => { // First wait for the loading bar to disappear
            this.animate(() => {
                this.animate(() => {
                    this.animate();
                    this.running = false;
                });
            });
        }, 1000);
    }

    private running = false;

    public stopAnimation(): void {
        this.hide();
        this.running = false;
        if (this.currentTimeout) clearTimeout(this.currentTimeout);
    }

    private animate(callback?: () => void) {
        if (!this.running) return;
        this.show();
        const startAlpha = this.system.arcCamera.alpha;
        this.anim.simple(200, (perc) => {
            if (!this.running) return;
            // let progress = Math.max(Math.min(2 * Math.sin(perc * Math.PI * 2.5), 1.5), -1.5) / 5;
            // let progress = Math.pow(Math.sin(perc * Math.PI * 1.5) / 2, 2);
            const opacity = Math.min(perc * 10, (1 - perc) * 10);
            this.el.style.opacity = opacity.toString();
            let progress: number;
            if (perc < 0.5) {
                progress = this.animEase.easing.ease(perc * 2);
            } else {
                progress = 1 - this.animEase.easing.ease((perc - 0.5) * 2);
            }
            progress /= 2;
            if (progress) {
                this.system.arcCamera.alpha = startAlpha - progress;
                this.setPosition(new Vector2(progress * 100, 0));
            }
        }, () => {
            this.hide();
            this.currentTimeout = setTimeout(() => {
                if (callback) callback();
            }, 2000);
        });
    }
}
